



































































































import { Component, Vue } from 'vue-property-decorator';

import {curApiKeyService, ApiKeyPage, ApiKeyService} from '@/services/ApiKeyService';

import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import ApiKeyRow from '@/components/access/ApiKeyRow.vue';
import ApiKeyRowMobile from '@/components/access/ApiKeyRowMobile.vue';
import PageNav from "@/components/PageNav.vue";
import SearchBox from "@/components/SearchBox.vue";
import CreateApiKey from '@/components/access/CreateApiKey.vue';
import EditApiKey from '@/components/access/EditApiKey.vue';
import DeleteApiKey from '@/components/access/DeleteApiKey.vue';
import { ApiKey } from '@/types/core';

import tippy from 'tippy.js'
import {curPref} from "@/services/Preferences";
import NumEntries from '@/components/NumEntries.vue';
import { CsvUtil } from '@/util/CsvUtil';
import moment from 'moment';
import fileDownload from 'js-file-download';
import _ from 'lodash';
import MqttManagementApiKey from "@/components/access/MqttManagementApiKey.vue";


@Component({
  components: {
    Loading,
    VueError,
    ApiKeyRow,
    CreateApiKey,
    EditApiKey,
    DeleteApiKey,
    MqttManagementApiKey,
    ApiKeyRowMobile,
    SearchBox,
    PageNav,
    NumEntries
  },
})
export default class ApiKeys extends Vue {

  apiKeyList:ApiKey[] = [];
  error:string = '';
  status:'view-all'|'create'|'edit'|'delete'|'mqtt' = 'view-all';
  selectedApiKey:ApiKey = {} as ApiKey;

  httpBusy:boolean = true;
  reqNo = 0;
  pageList:ApiKeyPage[] = [];
  curPage:ApiKeyPage = {} as ApiKeyPage;

  pageSize = 20;
  curOrderBy:any = 'apiKey';
  curAscDesc:any = 'asc';
  searchTerm = curPref.retrieve('v3-apikeys-search-term', '');

  // internal dependencies
  private apiKeyService:ApiKeyService = curApiKeyService;
  private csvUtil:CsvUtil = new CsvUtil();

  public $refs!: {
    'search-box': SearchBox
  };

  mounted() {
    tippy('[data-tippy-content]');
    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'delete'|'mqtt', selectedApiKey?:ApiKey) {
    
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedApiKey)
      this.selectedApiKey = selectedApiKey;
  }

  async refreshData(){
    // TODO: support more than 1000 api keys

    this.error = '';
    this.httpBusy = true;

    // prevents unwanted effects from race conditions now the search bar hangs around
    const currentReq:number = this.reqNo + 1;
    this.reqNo = currentReq;

    const reply = await this.apiKeyService.getApiKeys({
      orderBy:this.curOrderBy,
      ascDesc:this.curAscDesc,
      pageSize:this.pageSize,
      filter: this.searchTerm});

    // if this request has not been superceded then continue
    if (currentReq !== this.reqNo) {
      return
    }

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve api key list: ${reply.errorMsg}`;

    this.pageList = reply.apiKeyPageList as ApiKeyPage[];

    // we set the current page
    if(this.pageList.length > 0)
      this.curPage = this.pageList[0];
}

  newSearchText(newSearchText:string) {

    curPref.store('v3-apikeys-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  exportList() {

    let allApiKeyList = _.flatten(this.pageList.map(page => page.apiKeyList))
      
    let csvExport = this.csvUtil.apiKeysToCsv(allApiKeyList);

    let filename = `export-api-keys-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  get showPageNav():boolean {
    return !this.httpBusy && this.pageList.length > 0;
  }

  get showApiKeyRows():boolean {
    return !this.httpBusy && this.pageList.length > 0 && this.error === '';
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get showNoAccess():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm === '' && this.error === '';
  }

  get numEntries():number {
    return this.pageList.map(page => page.apiKeyList.length).reduce((acc, current) => acc+current, 0);
  }

  get showNumEntries():boolean {
    return !this.httpBusy;
  }

  get numEntriesExactNumber():boolean {
    return this.searchTerm === '';
  }

}
